import { render, staticRenderFns } from "./base-timeline.vue?vue&type=template&id=2c17fc6c&scoped=true&"
import script from "./base-timeline.vue?vue&type=script&lang=js&"
export * from "./base-timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17fc6c",
  null
  
)

export default component.exports